import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

class ItemPayment {
}
class CustomData {
}

const SPE_N_OPEN_ACCOUNT = '/spe-n-open-account';
let SpeNOpenAccountProxy = class SpeNOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getCep(zipcode) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/cep/${zipcode}`;
        return this.api.get(uri);
    }
};
SpeNOpenAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNOpenAccountProxy = __decorate([
    Injectable()
], SpeNOpenAccountProxy);

const SPE_N_USER_ACCOUNT = '/spe-n-user-account';
let SpeNUserAccountProxy = class SpeNUserAccountProxy {
    constructor(api) {
        this.api = api;
    }
    createPreAccount(account) {
        const uri = `${SPE_N_USER_ACCOUNT}/v1/`;
        return this.api.post(uri, account);
    }
    updatePreAccount(id, account) {
        const uri = `${SPE_N_USER_ACCOUNT}/v1/pre-account/${id}`;
        return this.api.put(uri, account);
    }
    updateStatusPreAccount(id, status) {
        const uri = `${SPE_N_USER_ACCOUNT}/v1/status/${status}/id/${id}`;
        const body = {};
        return this.api.put(uri, body);
    }
    updateRecurrence(id, recurrence) {
        const uri = `${SPE_N_USER_ACCOUNT}/v1/recurrence/id/${id}`;
        return this.api.put(uri, recurrence);
    }
    tryAgain(id) {
        const uri = `${SPE_N_USER_ACCOUNT}/v1/try-again/id/${id}`;
        return this.api.post(uri);
    }
};
SpeNUserAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNUserAccountProxy = __decorate([
    Injectable()
], SpeNUserAccountProxy);

const SPE_VIEW_N_USER_ACCOUNT = '/spe-view-n-user-account';
let SpeViewNUserAccountProxy = class SpeViewNUserAccountProxy {
    constructor(api) {
        this.api = api;
    }
    findById(id) {
        const uri = `${SPE_VIEW_N_USER_ACCOUNT}/v1/find-by-id/${id}`;
        return this.api.get(uri);
    }
    findPreUserAccount(uuidWhiteLabel, uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_USER_ACCOUNT}/v1/pre-user-account/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    findPreUserAccountByStatus(uuidWhiteLabel, uuidAccountPayment, status) {
        const uri = `${SPE_VIEW_N_USER_ACCOUNT}/v1/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/status/${status}`;
        return this.api.get(uri);
    }
    findPreUserAccountByDocument(uuidWhiteLabel, uuidAccountPayment, document) {
        const uri = `${SPE_VIEW_N_USER_ACCOUNT}/v1/document/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/document/${document}`;
        return this.api.get(uri);
    }
    findPreUserAccountByEmail(uuidWhiteLabel, uuidAccountPayment, email) {
        const uri = `${SPE_VIEW_N_USER_ACCOUNT}/v1/email/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/email/${email}`;
        return this.api.get(uri);
    }
    findPreUserAccountByUserName(uuidWhiteLabel, uuidAccountPayment, userName) {
        const uri = `${SPE_VIEW_N_USER_ACCOUNT}/v1/user-name/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/user-name/${userName}`;
        return this.api.get(uri);
    }
    verificationDocument(uuidWhiteLabel, document) {
        const uri = `${SPE_VIEW_N_USER_ACCOUNT}/v1/verification-document/${document}/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    verificationEmail(uuidWhiteLabel, email) {
        const uri = `${SPE_VIEW_N_USER_ACCOUNT}/v1/verification-email/${email}/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    verificationUserName(uuidWhiteLabel, userName) {
        const uri = `${SPE_VIEW_N_USER_ACCOUNT}/v1/verification-user-name/${userName}/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
};
SpeViewNUserAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNUserAccountProxy = __decorate([
    Injectable()
], SpeViewNUserAccountProxy);

const SPE_VIEW_N_PRIZE_DRAW = '/spe-view-n-prize-draw';
let SpeViewNPrizeDrawProxy = class SpeViewNPrizeDrawProxy {
    constructor(api) {
        this.api = api;
    }
    findPromotionData(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/promotion/find/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findUserIdAndPromoUuid(uuidWhiteLabel, user_id) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/user-promotion/find-by-id/white-label/${uuidWhiteLabel}/user-id/${user_id}`;
        return this.api.get(uri);
    }
    findUserNameAndPromoUuid(uuidWhiteLabel, username) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/user-promotion/find-by-username/white-label/${uuidWhiteLabel}/username/${username}`;
        return this.api.get(uri);
    }
    findUserIdAndCouponIdAndUuidWhiteLabel(uuidWhiteLabel, user_id, coupon_id) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/coupon/find-by-id/white-label/${uuidWhiteLabel}/user-id/${user_id}/coupon-id/${coupon_id}`;
        return this.api.get(uri);
    }
    findCouponUseridAndUuidWhiteLabel(uuidWhiteLabel, user_id) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/coupon/find/white-label/${uuidWhiteLabel}/user-id/${user_id}`;
        return this.api.get(uri);
    }
    findBlackListPerCpfAndUuidWl(uuidWhiteLabel, cpf) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/blacklist/find-by-cpf/white-label/${uuidWhiteLabel}/cpf/${cpf}`;
        return this.api.get(uri);
    }
    findBlackListPerUuidWl(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/blacklist/find/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findAwardPerUuidWl(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/awards/find/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findLuckNumerPerUuidWlAndUserId(uuidWhiteLabel, user_id) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/lucky-numbers/find/white-label/${uuidWhiteLabel}/user-id/${user_id}`;
        return this.api.get(uri);
    }
    findLastLuckyNumber(uuidWhiteLabel, user_id) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/lucky-number/find-last-lucky-number/white-label/${uuidWhiteLabel}/user-id/${user_id}`;
        return this.api.get(uri);
    }
    findLastDraw(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/raffles/find/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findDrawsByPeriod(uuidWhiteLabel, period) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/raffles/find-by-period/white-label/${uuidWhiteLabel}`;
        return this.api.post(uri, period);
    }
    findDrawsLastRegisters(uuidWhiteLabel, amount, period) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/raffles/find-last-raffles/white-label/${uuidWhiteLabel}/amount/${amount}`;
        return this.api.post(uri, period);
    }
    findWinners(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/winners/find/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findFAQ(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/faq/find/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findTermsAndRegulations(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/terms-regulations/find/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findOrders(uuidWhiteLabel, user_id) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/orders/find/white-label/${uuidWhiteLabel}/user-id/${user_id}`;
        return this.api.get(uri);
    }
    /////////////////// Payments
    findTransactions(uuidAccount) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/payment/resume/account/${uuidAccount}`;
        return this.api.get(uri);
    }
    findTransactionsByPeriod(uuidAccount, startDate, endDate) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/payment/resume-by-period/account/${uuidAccount}/period/?startDate=${startDate}&endDate=${endDate}`;
        return this.api.get(uri);
    }
    findPayments(uuidOrderCommerce, uuidAccountPaymentSeller, uuidWhiteLabelSeller) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/payment/wp/${uuidWhiteLabelSeller}/seller/${uuidAccountPaymentSeller}/orderId/${uuidOrderCommerce}`;
        return this.api.get(uri);
    }
    checkRecurrence(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/payment/recurrence/account/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    /////////////////// Publications
    findPublications(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/publications/find/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    /**
     * @description Método busca as publicações por período
     * @param period(ex. 2021-05-01 00:00:00 AND 2021-05-31 23:59:59)
     */
    findPublicationsByPeriod(uuidWhiteLabel, period) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/publications/find-by-period/white-label/${uuidWhiteLabel}/period/${period}`;
        return this.api.get(uri);
    }
    findPublicationsLastWinners(uuidWhiteLabel, amount) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/publications/last-winners/white-label/${uuidWhiteLabel}/amount/${amount}`;
        return this.api.get(uri);
    }
    findPublicationsLastDraws(uuidWhiteLabel, amount) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/publications/last-draws/white-label/${uuidWhiteLabel}/amount/${amount}`;
        return this.api.get(uri);
    }
    findPublicationsPrizes(uuidWhiteLabel, amount) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/publications/prizes/white-label/${uuidWhiteLabel}/amount/${amount}`;
        return this.api.get(uri);
    }
    findPrivateContent(uuidWhiteLabel, amount) {
        const uri = `${SPE_VIEW_N_PRIZE_DRAW}/v1/publications/private-content/white-label/${uuidWhiteLabel}/amount/${amount}`;
        return this.api.get(uri);
    }
};
SpeViewNPrizeDrawProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNPrizeDrawProxy = __decorate([
    Injectable()
], SpeViewNPrizeDrawProxy);

const SPE_N_PRIZE_DRAW = '/spe-n-prize-draw';
let SpeNPrizeDrawProxy = class SpeNPrizeDrawProxy {
    constructor(api) {
        this.api = api;
    }
    findUserPromoByUuidWlAndUserId(uuidWhiteLabel, user_id) {
        const uri = `${SPE_N_PRIZE_DRAW}/v1/user-promotion/find-by-id/white-label/${uuidWhiteLabel}/user-id/${user_id}`;
        return this.api.get(uri);
    }
    findUserPromoByUuidWlAndUserName(uuidWhiteLabel, username) {
        const uri = `${SPE_N_PRIZE_DRAW}/v1/user-promotion/find-by-username/white-label/${uuidWhiteLabel}/username/${username}`;
        return this.api.get(uri);
    }
    createUser(uuidWhiteLabel, prizeDrawUsers) {
        const uri = `${SPE_N_PRIZE_DRAW}/v1/user-promotion/create/white-label/${uuidWhiteLabel}`;
        return this.api.post(uri, prizeDrawUsers);
    }
    updateUser(uuidWhiteLabel, prizeDrawUsers) {
        const uri = `${SPE_N_PRIZE_DRAW}/v1/user-promotion/update/white-label/${uuidWhiteLabel}`;
        return this.api.put(uri, prizeDrawUsers);
    }
    deleteUser(uuidWhiteLabel, uuidAccountPayment, userId) {
        const uri = `${SPE_N_PRIZE_DRAW}/v1/user-promotion/delete/white-label/${uuidWhiteLabel}/account/${uuidAccountPayment}/user/${userId}`;
        return this.api.delete(uri);
    }
    registerSupport(uuidWhiteLabel, supportBody) {
        const uri = `${SPE_N_PRIZE_DRAW}/v1/user-support/create/white-label/${uuidWhiteLabel}`;
        return this.api.post(uri, supportBody);
    }
    updateSupport(uuidWhiteLabel, supportBody) {
        const uri = `${SPE_N_PRIZE_DRAW}/v1/user-support/update/white-label/${uuidWhiteLabel}`;
        return this.api.put(uri, supportBody);
    }
    makeThePayment(paymentBody) {
        const uri = `${SPE_N_PRIZE_DRAW}/v1/payment/`;
        return this.api.post(uri, paymentBody);
    }
    checkPurchaseAtLastWeek(uuidAccountPayment) {
        const uri = `${SPE_N_PRIZE_DRAW}/v1/payment/uuidAccountPaymentCustomer/${uuidAccountPayment}/check7DaysOrders`;
        return this.api.get(uri);
    }
};
SpeNPrizeDrawProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNPrizeDrawProxy = __decorate([
    Injectable()
], SpeNPrizeDrawProxy);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getWallets(uuidWhiteLabel, uuidAccount) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/wallets/ap/${uuidAccount}/wl/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNAccountProxy = __decorate([
    Injectable()
], SpeViewNAccountProxy);

const SPE_EXT_USERS = '/users';
let SpeExtUsersProxy = class SpeExtUsersProxy {
    constructor(api) {
        this.api = api;
    }
    updatePassword(passwordBody) {
        const uri = `${SPE_EXT_USERS}/v1/password`;
        return this.api.put(uri, passwordBody);
    }
};
SpeExtUsersProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeExtUsersProxy = __decorate([
    Injectable()
], SpeExtUsersProxy);

const SPE_J_NOTIFICATION = '/spe-j-notification';
let SpeJNotificationProxy = class SpeJNotificationProxy {
    constructor(api) {
        this.api = api;
    }
    sendEmail(message) {
        const uri = `${SPE_J_NOTIFICATION}/api/send/email`;
        return this.api.post(uri, message);
    }
};
SpeJNotificationProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJNotificationProxy = __decorate([
    Injectable()
], SpeJNotificationProxy);

const SPE_J_ORDER_COMMERCE = '/spe-j-order-commerce';
let SpeJOrderCommerce = class SpeJOrderCommerce {
    constructor(api) {
        this.api = api;
    }
    findByUuid(uuidOrderCommerce) {
        const uri = `${SPE_J_ORDER_COMMERCE}/api/orderCommerce/${uuidOrderCommerce}`;
        return this.api.get(uri);
    }
    findByUuidWithPayment(uuidOrderCommerce) {
        const uri = `${SPE_J_ORDER_COMMERCE}/api/orderCommerce/${uuidOrderCommerce}/payment`;
        return this.api.get(uri);
    }
};
SpeJOrderCommerce.ctorParameters = () => [
    { type: ApiService }
];
SpeJOrderCommerce = __decorate([
    Injectable()
], SpeJOrderCommerce);

let UiPxPrizeDrawModule = class UiPxPrizeDrawModule {
};
UiPxPrizeDrawModule = __decorate([
    NgModule({
        declarations: [],
        imports: [UiBsOauthModule],
        providers: [
            ConfigService,
            SpeExtUsersProxy,
            SpeNOpenAccountProxy,
            SpeNPrizeDrawProxy,
            SpeNUserAccountProxy,
            SpeViewNAccountProxy,
            SpeViewNPrizeDrawProxy,
            SpeViewNUserAccountProxy,
            SpeJNotificationProxy,
            SpeJOrderCommerce,
        ],
    })
], UiPxPrizeDrawModule);

var StatusPreAccountEnum;
(function (StatusPreAccountEnum) {
    StatusPreAccountEnum["IN_ONBOARDING"] = "IN_ONBOARDING";
    StatusPreAccountEnum["IN_ANALYSIS"] = "IN_ANALYSIS";
    StatusPreAccountEnum["APPROVED"] = "APPROVED";
    StatusPreAccountEnum["REPROVED"] = "REPROVED";
    StatusPreAccountEnum["RETURNED"] = "RETURNED";
})(StatusPreAccountEnum || (StatusPreAccountEnum = {}));

var TypeUserEnum;
(function (TypeUserEnum) {
    TypeUserEnum["DEFAULT"] = "DEFAULT";
    TypeUserEnum["FREEMIUM"] = "FREEMIUM";
    TypeUserEnum["FREEMIUM_CP"] = "FREEMIUM_CP";
    TypeUserEnum["PREMIUM"] = "PREMIUM";
    TypeUserEnum["PREMIUM_CP"] = "PREMIUM_CP";
    TypeUserEnum["PARTNER"] = "PARTNER";
})(TypeUserEnum || (TypeUserEnum = {}));

var TypeEmailEnum;
(function (TypeEmailEnum) {
    TypeEmailEnum["SIMPLE"] = "SIMPLE";
    TypeEmailEnum["MIME"] = "MIME";
})(TypeEmailEnum || (TypeEmailEnum = {}));

var TypeTemplateEnum;
(function (TypeTemplateEnum) {
    TypeTemplateEnum["WELCOME"] = "WELCOME";
    TypeTemplateEnum["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    TypeTemplateEnum["RESEND_ACTIVE_ACCOUNT"] = "RESEND_ACTIVE_ACCOUNT";
    TypeTemplateEnum["PAYMENT_APPROVED"] = "PAYMENT_APPROVED";
    TypeTemplateEnum["PAYMENT_NOT_AUTHORIZED"] = "PAYMENT_NOT_AUTHORIZED";
    TypeTemplateEnum["PAYMENT_APPROVED_SELLER"] = "PAYMENT_APPROVED_SELLER";
    TypeTemplateEnum["PAYMENT_NOT_APPROVED_SELLER"] = "PAYMENT_NOT_APPROVED_SELLER";
    TypeTemplateEnum["PURCHASE_MADE"] = "PURCHASE_MADE";
    TypeTemplateEnum["LINK_PURCHASE"] = "LINK_PURCHASE";
    TypeTemplateEnum["WELCOME_CUSTOMER"] = "WELCOME_CUSTOMER";
    TypeTemplateEnum["CUSTOM"] = "CUSTOM";
})(TypeTemplateEnum || (TypeTemplateEnum = {}));

/*
 * Public API Surface of ui-px-prizedraw
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, CustomData, ItemPayment, SpeExtUsersProxy, SpeJNotificationProxy, SpeJOrderCommerce, SpeNOpenAccountProxy, SpeNPrizeDrawProxy, SpeNUserAccountProxy, SpeViewNAccountProxy, SpeViewNPrizeDrawProxy, SpeViewNUserAccountProxy, StatusPreAccountEnum, TypeEmailEnum, TypeTemplateEnum, TypeUserEnum, UiPxPrizeDrawModule };
//# sourceMappingURL=wlp-ui-px-prizedraw.js.map
